export default __webpack_public_path__ + "static/media/delete.e1f71352.svg";